import { Locale } from 'chaika-enums';

import { DateHelper } from '@utils/DateHelper';
import { Declension } from '@utils/Declension';

export function formatAgeString(birthDate: Date, locale: Locale = Locale.Ru): string {
    const { years, months, weeks, days } = DateHelper.getFullAge(birthDate);
    if (years < 4) {
        return DateHelper.makeAgeString({ birthDate, locale });
    }
    const isEng = locale === Locale.En;
    return years > 0
        ? `${years} ${isEng ? Declension.yearsEng(years) : Declension.years(years)}`
        : months > 0
          ? `${months} ${isEng ? Declension.monthsEng(months) : Declension.months(months)}`
          : weeks > 0
            ? `${weeks} ${isEng ? Declension.weekEng(weeks) : Declension.week(weeks)}`
            : `${days} ${isEng ? Declension.daysEng(days) : Declension.days(days)}`;
}
